import { OrderByDirection } from '@freelancer/datastore';
import type { Backend } from '@freelancer/datastore/core';
import type { UserTaxOptOutReasonsCollection } from './user-tax-opt-out-reasons.types';

export function userTaxOptOutReasonsBackend(): Backend<UserTaxOptOutReasonsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/self/tax/opt_out',
    }),
    push: (authUid, reason) => ({
      method: 'POST',
      endpoint: 'users/0.1/self/tax/opt_out',
      payload: {
        reason_id: reason.reasonId,
        details: reason.details,
      },
    }),
    set: (authUid, reason) => ({
      method: 'POST',
      endpoint: 'users/0.1/self/tax/opt_out',
      payload: {
        reason_id: reason.reasonId,
        details: reason.details,
      },
    }),
    update: undefined,
    remove: (authUid, reasonId) => ({
      method: 'DELETE',
      endpoint: `users/0.1/self/tax/opt_out/${reasonId}`,
      payload: {},
    }),
  };
}
